<div *ngIf="(employees$ | async).length == 0" class="sso-splash-screen">
  <h1>{{ "logging_in" | translate }}</h1>
</div>
<select-office *ngIf="(employees$ | async).length > 0"></select-office>
